import { library } from '@fortawesome/fontawesome-svg-core';
// fad: duotone
import { faAbacus as fadAbacus } from '@fortawesome/pro-duotone-svg-icons/faAbacus';
import { faAddressBook as fadAddressBook } from '@fortawesome/pro-duotone-svg-icons/faAddressBook';
import { faAddressCard as fadAddressCard } from '@fortawesome/pro-duotone-svg-icons/faAddressCard';
import { faAlarmClock as fadAlarmClock } from '@fortawesome/pro-duotone-svg-icons/faAlarmClock';
import { faAlarmSnooze as fadAlarmSnooze } from '@fortawesome/pro-duotone-svg-icons/faAlarmSnooze';
import { faArrowDownUpLock as fadArrowDownUpLock } from '@fortawesome/pro-duotone-svg-icons/faArrowDownUpLock';
import { faBan as fadBan } from '@fortawesome/pro-duotone-svg-icons/faBan';
import { faBed as fadBed } from '@fortawesome/pro-duotone-svg-icons/faBed';
import { faBedFront as fadBedFront } from '@fortawesome/pro-duotone-svg-icons/faBedFront';
import { faBell as fadBell } from '@fortawesome/pro-duotone-svg-icons/faBell';
import { faCalendarDay as fadCalendarDay } from '@fortawesome/pro-duotone-svg-icons/faCalendarDay';
import { faCalendarDays as fadCalendarDays } from '@fortawesome/pro-duotone-svg-icons/faCalendarDays';
import { faCapsules as fadCapsules } from '@fortawesome/pro-duotone-svg-icons/faCapsules';
import { faChartSimple as fadChartSimple } from '@fortawesome/pro-duotone-svg-icons/faChartSimple';
import { faCheck as fadCheck } from '@fortawesome/pro-duotone-svg-icons/faCheck';
import { faChevronDown as fadChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import { faChevronRight as fadChevronRight } from '@fortawesome/pro-duotone-svg-icons/faChevronRight';
import { faCircleCheck as fadCircleCheck } from '@fortawesome/pro-duotone-svg-icons/faCircleCheck';
import { faCircleChevronDown as fadCircleChevronDown } from '@fortawesome/pro-duotone-svg-icons/faCircleChevronDown';
import { faCircleChevronLeft as fadCircleChevronLeft } from '@fortawesome/pro-duotone-svg-icons/faCircleChevronLeft';
import { faCircleChevronRight as fadCircleChevronRight } from '@fortawesome/pro-duotone-svg-icons/faCircleChevronRight';
import { faCircleExclamation as fadCircleExclamation } from '@fortawesome/pro-duotone-svg-icons/faCircleExclamation';
import { faCircleInfo as fadCircleInfo } from '@fortawesome/pro-duotone-svg-icons/faCircleInfo';
import { faCircleMinus as fadCircleMinus } from '@fortawesome/pro-duotone-svg-icons/faCircleMinus';
import { faCircleUser as fadCircleUser } from '@fortawesome/pro-duotone-svg-icons/faCircleUser';
import { faCircleX as fadCircleX } from '@fortawesome/pro-duotone-svg-icons/faCircleX';
import { faCircleXmark as fadCircleXmark } from '@fortawesome/pro-duotone-svg-icons/faCircleXmark';
import { faCity as fadCity } from '@fortawesome/pro-duotone-svg-icons/faCity';
import { faClipboardMedical as fadClipboardMedical } from '@fortawesome/pro-duotone-svg-icons/faClipboardMedical';
import { faCommentDots as fadCommentDots } from '@fortawesome/pro-duotone-svg-icons/faCommentDots';
import { faCommentQuestion as fadCommentQuestion } from '@fortawesome/pro-duotone-svg-icons/faCommentQuestion';
import { faCopy as fadCopy } from '@fortawesome/pro-duotone-svg-icons/faCopy';
import { faDash as fadDash } from '@fortawesome/pro-duotone-svg-icons/faDash';
import { faDisplayMedical as fadDisplayMedical } from '@fortawesome/pro-duotone-svg-icons/faDisplayMedical';
import { faDna as fadDna } from '@fortawesome/pro-duotone-svg-icons/faDna';
import { faDownload as fadDownload } from '@fortawesome/pro-duotone-svg-icons/faDownload';
import { faDroplet as fadDroplet } from '@fortawesome/pro-duotone-svg-icons/faDroplet';
import { faDumbbell as fadDumbbell } from '@fortawesome/pro-duotone-svg-icons/faDumbbell';
import { faEllipsisStroke as fadEllipsisStroke } from '@fortawesome/pro-duotone-svg-icons/faEllipsisStroke';
import { faExpand as fadExpand } from '@fortawesome/pro-duotone-svg-icons/faExpand';
import { faExpandWide as fadExpandWide } from '@fortawesome/pro-duotone-svg-icons/faExpandWide';
import { faEye as fadEye } from '@fortawesome/pro-duotone-svg-icons/faEye';
import { faFaceSleeping as fadFaceSleeping } from '@fortawesome/pro-duotone-svg-icons/faFaceSleeping';
import { faFaceSmile as fadFaceSmile } from '@fortawesome/pro-duotone-svg-icons/faFaceSmile';
import { faFaceViewfinder as fadFaceViewfinder } from '@fortawesome/pro-duotone-svg-icons/faFaceViewfinder';
import { faFile as fadFile } from '@fortawesome/pro-duotone-svg-icons/faFile';
import { faFileLines as fadFileLines } from '@fortawesome/pro-duotone-svg-icons/faFileLines';
import { faFileMedical as fadFileMedical } from '@fortawesome/pro-duotone-svg-icons/faFileMedical';
import { faFilePdf as fadFilePdf } from '@fortawesome/pro-duotone-svg-icons/faFilePdf';
import { faFiles as fadFiles } from '@fortawesome/pro-duotone-svg-icons/faFiles';
import { faFilesMedical as fadFilesMedical } from '@fortawesome/pro-duotone-svg-icons/faFilesMedical';
import { faFireFlame as fadFireFlame } from '@fortawesome/pro-duotone-svg-icons/faFireFlame';
import { faFireFlameCurved as fadFireFlameCurved } from '@fortawesome/pro-duotone-svg-icons/faFireFlameCurved';
import { faFolderMedical as fadFolderMedical } from '@fortawesome/pro-duotone-svg-icons/faFolderMedical';
import { faGauge as fadGauge } from '@fortawesome/pro-duotone-svg-icons/faGauge';
import { faGaugeCircleBolt as fadGaugeCircleBolt } from '@fortawesome/pro-duotone-svg-icons/faGaugeCircleBolt';
import { faGavel as fadGavel } from '@fortawesome/pro-duotone-svg-icons/faGavel';
import { faGear as fadGear } from '@fortawesome/pro-duotone-svg-icons/faGear';
import { faHandDots as fadHandDots } from '@fortawesome/pro-duotone-svg-icons/faHandDots';
import { faHeadSideCough as fadHeadSideCough } from '@fortawesome/pro-duotone-svg-icons/faHeadSideCough';
import { faHeart as fadHeart } from '@fortawesome/pro-duotone-svg-icons/faHeart';
import { faHeartPulse as fadHeartPulse } from '@fortawesome/pro-duotone-svg-icons/faHeartPulse';
import { faHistory as fasHistory } from '@fortawesome/pro-duotone-svg-icons/faHistory';
import { faHome as fadHome } from '@fortawesome/pro-duotone-svg-icons/faHome';
import { faHorizontalRule as fadHorizontalRule } from '@fortawesome/pro-duotone-svg-icons/faHorizontalRule';
import { faHospitalWide as fadHospitalWide } from '@fortawesome/pro-duotone-svg-icons/faHospitalWide';
import { faHyphen as fadHyphen } from '@fortawesome/pro-duotone-svg-icons/faHyphen';
import { faIdCard as fadIdCard } from '@fortawesome/pro-duotone-svg-icons/faIdCard';
import { faImage as fadImage } from '@fortawesome/pro-duotone-svg-icons/faImage';
import { faImageSlash as fadImageSlash } from '@fortawesome/pro-duotone-svg-icons/faImageSlash';
import { faImages as fadImages } from '@fortawesome/pro-duotone-svg-icons/faImages';
import { faKey as fadKey } from '@fortawesome/pro-duotone-svg-icons/faKey';
import { faLaptopMedical as fadLaptopMedical } from '@fortawesome/pro-duotone-svg-icons/faLaptopMedical';
import { faLocationDot as fadLocationDot } from '@fortawesome/pro-duotone-svg-icons/faLocationDot';
import { faLock as fadLock } from '@fortawesome/pro-duotone-svg-icons/faLock';
import { faLungs as fadLungs } from '@fortawesome/pro-duotone-svg-icons/faLungs';
import { faMagnifyingGlass as fadMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassChart as fadMagnifyingGlassChart } from '@fortawesome/pro-duotone-svg-icons/faMagnifyingGlassChart';
import { faMonitorWaveform as fadMonitorWaveform } from '@fortawesome/pro-duotone-svg-icons/faMonitorWaveform';
import { faNotesMedical as fadNotesMedical } from '@fortawesome/pro-duotone-svg-icons/faNotesMedical';
import { faPaperPlane as fadPaperPlane } from '@fortawesome/pro-duotone-svg-icons/faPaperPlane';
import { faPen as fadPen } from '@fortawesome/pro-duotone-svg-icons/faPen';
import { faPerson as fadPerson } from '@fortawesome/pro-duotone-svg-icons/faPerson';
import { faPersonDotsFromLine as fadPersonDotsFromLine } from '@fortawesome/pro-duotone-svg-icons/faPersonDotsFromLine';
import { faPersonRunningFast as fadPersonRunningFast } from '@fortawesome/pro-duotone-svg-icons/faPersonRunningFast';
import { faPersonWalking as fadPersonWalking } from '@fortawesome/pro-duotone-svg-icons/faPersonWalking';
import { faPhone as fadPhone } from '@fortawesome/pro-duotone-svg-icons/faPhone';
import { faPlug as fadPlug } from '@fortawesome/pro-duotone-svg-icons/faPlug';
import { faPlus as fadPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus';
import { faRepeat as fadRepeat } from '@fortawesome/pro-duotone-svg-icons/faRepeat';
import { faRightFromBracket as fadRightFromBracket } from '@fortawesome/pro-duotone-svg-icons/faRightFromBracket';
import { faRulerHorizontal as fadRulerHorizontal } from '@fortawesome/pro-duotone-svg-icons/faRulerHorizontal';
import { faRulerVertical as fadRulerVertical } from '@fortawesome/pro-duotone-svg-icons/faRulerVertical';
import { faScalpelLineDashed as fadScalpelLineDashed } from '@fortawesome/pro-duotone-svg-icons/faScalpelLineDashed';
import { faScrewdriverWrench as fadScrewdriverWrench } from '@fortawesome/pro-duotone-svg-icons/faScrewdriverWrench';
import { faShareNodes as fadShareNodes } from '@fortawesome/pro-duotone-svg-icons/faShareNodes';
import { faShieldHalved as fadShieldHalved } from '@fortawesome/pro-duotone-svg-icons/faShieldHalved';
import { faShoePrints as fadShoePrints } from '@fortawesome/pro-duotone-svg-icons/faShoePrints';
import { faSitemap as fadSitemap } from '@fortawesome/pro-duotone-svg-icons/faSitemap';
import { faSliders as fadSliders } from '@fortawesome/pro-duotone-svg-icons/faSliders';
import { faSnooze as fadSnooze } from '@fortawesome/pro-duotone-svg-icons/faSnooze';
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import { faStethoscope as fadStethoscope } from '@fortawesome/pro-duotone-svg-icons/faStethoscope';
import { faSyringe as fadSyringe } from '@fortawesome/pro-duotone-svg-icons/faSyringe';
import { faTemperatureHalf as fadTemperatureHalf } from '@fortawesome/pro-duotone-svg-icons/faTemperatureHalf';
import { faTimeline as fadTimeline } from '@fortawesome/pro-duotone-svg-icons/faTimeline';
import { faTrash as fadTrash } from '@fortawesome/pro-duotone-svg-icons/faTrash';
import { faTriangleExclamation as fadTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons/faTriangleExclamation';
import { faTrophyStar as fadTrophyStar } from '@fortawesome/pro-duotone-svg-icons/faTrophyStar';
import { faTruckMedical as fadTruckMedical } from '@fortawesome/pro-duotone-svg-icons/faTruckMedical';
import { faUser as fadUser } from '@fortawesome/pro-duotone-svg-icons/faUser';
import { faUserDoctor as fadUserDoctor } from '@fortawesome/pro-duotone-svg-icons/faUserDoctor';
import { faUserLarge as fadUserLarge } from '@fortawesome/pro-duotone-svg-icons/faUserLarge';
import { faUserLock as fadUserLock } from '@fortawesome/pro-duotone-svg-icons/faUserLock';
import { faUserMinus as fadUserMinus } from '@fortawesome/pro-duotone-svg-icons/faUserMinus';
import { faUserNurse as fadUserNurse } from '@fortawesome/pro-duotone-svg-icons/faUserNurse';
import { faUserPlus as fadUserPlus } from '@fortawesome/pro-duotone-svg-icons/faUserPlus';
import { faUserShield as fadUserShield } from '@fortawesome/pro-duotone-svg-icons/faUserShield';
import { faUsers as fadUsers } from '@fortawesome/pro-duotone-svg-icons/faUsers';
import { faVials as fadVials } from '@fortawesome/pro-duotone-svg-icons/faVials';
import { faWatchFitness as fadWatchFitness } from '@fortawesome/pro-duotone-svg-icons/faWatchFitness';
import { faWavePulse as fadWavePulse } from '@fortawesome/pro-duotone-svg-icons/faWavePulse';
import { faWeightScale as fadWeightScale } from '@fortawesome/pro-duotone-svg-icons/faWeightScale';
import { faWrench as fadWrench } from '@fortawesome/pro-duotone-svg-icons/faWrench';
import { faBars as falBars } from '@fortawesome/pro-light-svg-icons/faBars';
import { faCircleInfo as falCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faSliders as falSliders } from '@fortawesome/pro-light-svg-icons/faSliders';
import { faBed as farBed } from '@fortawesome/pro-regular-svg-icons/faBed';
import { faBrain as farBrain } from '@fortawesome/pro-regular-svg-icons/faBrain';
import { faCalendarDays as farCalendarDays } from '@fortawesome/pro-regular-svg-icons/faCalendarDays';
import { faCapsules as farCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules';
import { faChartSimple as farChartSimple } from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import { faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faCircle as farCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircleCheck as farCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faCircleInfo as farCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCircleQuestion as farCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faClipboard as farClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faDna as farDna } from '@fortawesome/pro-regular-svg-icons/faDna';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faHandDots as farHandDots } from '@fortawesome/pro-regular-svg-icons/faHandDots';
import { faHospitalWide as farHospitalWide } from '@fortawesome/pro-regular-svg-icons/faHospitalWide';
import { faImages as farImages } from '@fortawesome/pro-regular-svg-icons/faImages';
import { faMessage as farMessage } from '@fortawesome/pro-regular-svg-icons/faMessage';
import { faMinus as farMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faMobile as farMobile } from '@fortawesome/pro-regular-svg-icons/faMobile';
import { faMonitorWaveform as farMonitorWaveform } from '@fortawesome/pro-regular-svg-icons/faMonitorWaveform';
import { faNotesMedical as farNotesMedical } from '@fortawesome/pro-regular-svg-icons/faNotesMedical';
import { faPaperclip as farPaperclip } from '@fortawesome/pro-regular-svg-icons/faPaperclip';
import { faPerson as farPerson } from '@fortawesome/pro-regular-svg-icons/faPerson';
import { faPersonRunningFast as farPersonRunningFast } from '@fortawesome/pro-regular-svg-icons/faPersonRunningFast';
import { faPersonWalking as farPersonWalking } from '@fortawesome/pro-regular-svg-icons/faPersonWalking';
import { faRepeat as farRepeat } from '@fortawesome/pro-regular-svg-icons/faRepeat';
import { faScalpelLineDashed as farScalpelLineDashed } from '@fortawesome/pro-regular-svg-icons/faScalpelLineDashed';
import { faSnooze as farSnooze } from '@fortawesome/pro-regular-svg-icons/faSnooze';
import { faSquare as farSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faStethoscope as farStethoscope } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { faSyringe as farSyringe } from '@fortawesome/pro-regular-svg-icons/faSyringe';
import { faTruckMedical as farTruckMedical } from '@fortawesome/pro-regular-svg-icons/faTruckMedical';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUsers as farUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faVials as farVials } from '@fortawesome/pro-regular-svg-icons/faVials';
// fas: solid
import { fa2 as fas2 } from '@fortawesome/pro-solid-svg-icons/fa2';
import { faAddressBook as fasAddressBook } from '@fortawesome/pro-solid-svg-icons/faAddressBook';
import { faAlarmClock as fasAlarmClock } from '@fortawesome/pro-solid-svg-icons/faAlarmClock';
import { faAlarmSnooze as fasAlarmSnooze } from '@fortawesome/pro-solid-svg-icons/faAlarmSnooze';
import { faArrowDown as fasArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowLeft as fasArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight as fasArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowRotateRight as fasArrowRotateRight } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight';
import { faArrowUp as fasArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faBrain as fasBrain } from '@fortawesome/pro-solid-svg-icons/faBrain';
import { faCalendarCheck as fasCalendarCheck } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faChartSimple as fasChartSimple } from '@fortawesome/pro-solid-svg-icons/faChartSimple';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronsDown as fasChevronsDown } from '@fortawesome/pro-solid-svg-icons/faChevronsDown';
import { faChevronsUp as fasChevronsUp } from '@fortawesome/pro-solid-svg-icons/faChevronsUp';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleCheck as fasCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCirclePause as fasCirclePause } from '@fortawesome/pro-solid-svg-icons/faCirclePause';
import { faCirclePlay as fasCirclePlay } from '@fortawesome/pro-solid-svg-icons/faCirclePlay';
import { faCircleSmall as fasCircleSmall } from '@fortawesome/pro-solid-svg-icons/faCircleSmall';
import { faCircleUser as fasCircleUser } from '@fortawesome/pro-solid-svg-icons/faCircleUser';
import { faCircleX as fasCircleX } from '@fortawesome/pro-solid-svg-icons/faCircleX';
import { faCircleXmark as fasCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faClipboardMedical as fasClipboardMedical } from '@fortawesome/pro-solid-svg-icons/faClipboardMedical';
import { faClockRotateLeft as fasClockRotateLeft } from '@fortawesome/pro-solid-svg-icons/faClockRotateLeft';
import { faCloudArrowUp as fasCloudArrowUp } from '@fortawesome/pro-solid-svg-icons/faCloudArrowUp';
import { faComment as fasComment } from '@fortawesome/pro-solid-svg-icons/faComment';
import { faCopy as fasCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { faDash as fasDash } from '@fortawesome/pro-solid-svg-icons/faDash';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faDroplet as fasDroplet } from '@fortawesome/pro-solid-svg-icons/faDroplet';
import { faDumbbell as fasDumbbell } from '@fortawesome/pro-solid-svg-icons/faDumbbell';
import { faEllipsis as fasEllipsis } from '@fortawesome/pro-solid-svg-icons/faEllipsis';
import { faEllipsisStroke as fasEllipsisStroke } from '@fortawesome/pro-solid-svg-icons/faEllipsisStroke';
import { faEllipsisVertical as fasEllipsisVertical } from '@fortawesome/pro-solid-svg-icons/faEllipsisVertical';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeCircleCheck as fasEnvelopeCircleCheck } from '@fortawesome/pro-solid-svg-icons/faEnvelopeCircleCheck';
import { faExpand as fasExpand } from '@fortawesome/pro-solid-svg-icons/faExpand';
import { faEye as fasEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faFaceSleeping as fasFaceSleeping } from '@fortawesome/pro-solid-svg-icons/faFaceSleeping';
import { faFaceSmile as fasFaceSmile } from '@fortawesome/pro-solid-svg-icons/faFaceSmile';
import { faFaceViewfinder as fasFaceViewFinder } from '@fortawesome/pro-solid-svg-icons/faFaceViewfinder';
import { faFile as fasFile } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faFileExport as fasFileExport } from '@fortawesome/pro-solid-svg-icons/faFileExport';
import { faFileLines as fasFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFireFlame as fasFireFlame } from '@fortawesome/pro-solid-svg-icons/faFireFlame';
import { faFireFlameCurved as fasFireFlameCurved } from '@fortawesome/pro-solid-svg-icons/faFireFlameCurved';
import { faFolderMedical as fasFolderMedical } from '@fortawesome/pro-solid-svg-icons/faFolderMedical';
import { faGauge as fasGauge } from '@fortawesome/pro-solid-svg-icons/faGauge';
import { faGaugeCircleBolt as fasGaugeCircleBolt } from '@fortawesome/pro-solid-svg-icons/faGaugeCircleBolt';
import { faGear as fasGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faGrid as fasGrid } from '@fortawesome/pro-solid-svg-icons/faGrid';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHeartPulse as fasHeartPulse } from '@fortawesome/pro-solid-svg-icons/faHeartPulse';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faHospitalUser as fasHospitalUser } from '@fortawesome/pro-solid-svg-icons/faHospitalUser';
import { faHyphen as fasHyphen } from '@fortawesome/pro-solid-svg-icons/faHyphen';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faInfo as fasInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faLoader as fasLoader } from '@fortawesome/pro-solid-svg-icons/faLoader';
import { faLocationDot as fasLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import { faLungs as fasLungs } from '@fortawesome/pro-solid-svg-icons/faLungs';
import { faMagnifyingGlass as fasMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassChart as fasMagnifyingGlassChart } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassChart';
import { faMerge as fasMerge } from '@fortawesome/pro-solid-svg-icons/faMerge';
import { faMessageSms as fasMessageSms } from '@fortawesome/pro-solid-svg-icons/faMessageSms';
import { faMessageXmark as fasMessageXmark } from '@fortawesome/pro-solid-svg-icons/faMessageXmark';
import { faMinus as fasMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faMonitorWaveform as fasMonitorWaveform } from '@fortawesome/pro-solid-svg-icons/faMonitorWaveform';
import { faMoon as fasMoon } from '@fortawesome/pro-solid-svg-icons/faMoon';
import { faMoonStars as fasMoonStars } from '@fortawesome/pro-solid-svg-icons/faMoonStars';
import { faPalette as fasPalette } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faPencil as fasPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPerson as fasPerson } from '@fortawesome/pro-solid-svg-icons/faPerson';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPlug as fasPlug } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faPlus as fasPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faRightLeft as fasRightLeft } from '@fortawesome/pro-solid-svg-icons/faRightLeft';
import { faRulerHorizontal as fasRulerHorizontal } from '@fortawesome/pro-solid-svg-icons/faRulerHorizontal';
import { faRulerVertical as fasRulerVertical } from '@fortawesome/pro-solid-svg-icons/faRulerVertical';
import { faShareNodes as fasShareNodes } from '@fortawesome/pro-solid-svg-icons/faShareNodes';
import { faShield as fasShield } from '@fortawesome/pro-solid-svg-icons/faShield';
import { faShoePrints as fasShoePrints } from '@fortawesome/pro-solid-svg-icons/faShoePrints';
import { faSitemap as fasSitemap } from '@fortawesome/pro-solid-svg-icons/faSitemap';
import { faSplit as fasSplit } from '@fortawesome/pro-solid-svg-icons/faSplit';
import { faSquare as fasSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faSquareCheck as fasSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faSun as fasSun } from '@fortawesome/pro-solid-svg-icons/faSun';
import { faTable as fasTable } from '@fortawesome/pro-solid-svg-icons/faTable';
import { faTemperatureHalf as fasTemperatureHalf } from '@fortawesome/pro-solid-svg-icons/faTemperatureHalf';
import { faTilde as fasTilde } from '@fortawesome/pro-solid-svg-icons/faTilde';
import { faTimeline as fasTimeline } from '@fortawesome/pro-solid-svg-icons/faTimeline';
import { faTrash as fasTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTrashArrowUp as fasTrashArrowUp } from '@fortawesome/pro-solid-svg-icons/faTrashArrowUp';
import { faTriangleExclamation as fasTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserDoctor as fasUserDoctor } from '@fortawesome/pro-solid-svg-icons/faUserDoctor';
import { faUserMagnifyingGlass as fasUserMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faUserMagnifyingGlass';
import { faUsers as fasUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUsersGear as fasUsersGear } from '@fortawesome/pro-solid-svg-icons/faUsersGear';
import { faWatchFitness as fasWatchFitness } from '@fortawesome/pro-solid-svg-icons/faWatchFitness';
import { faWavePulse as fasWavePulse } from '@fortawesome/pro-solid-svg-icons/faWavePulse';
import { faWeightScale as fasWeightScale } from '@fortawesome/pro-solid-svg-icons/faWeightScale';
import { faWind as fasWind } from '@fortawesome/pro-solid-svg-icons/faWind';
import { faWrench as fasWrench } from '@fortawesome/pro-solid-svg-icons/faWrench';
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
// FAT: thin
import { faAddressBook as fatAddressBook } from '@fortawesome/pro-thin-svg-icons/faAddressBook';
import { faAlarmClock as fatAlarmClock } from '@fortawesome/pro-thin-svg-icons/faAlarmClock';
import { faArrowLeft as fatArrowLeft } from '@fortawesome/pro-thin-svg-icons/faArrowLeft';
import { faArrowRight as fatArrowRight } from '@fortawesome/pro-thin-svg-icons/faArrowRight';
import { faBrain as fatBrain } from '@fortawesome/pro-thin-svg-icons/faBrain';
import { faCircle as fatCircle } from '@fortawesome/pro-thin-svg-icons/faCircle';
import { faClipboardMedical as fatClipboardMedical } from '@fortawesome/pro-thin-svg-icons/faClipboardMedical';
import { faComment as fatComment } from '@fortawesome/pro-thin-svg-icons/faComment';
import { faDroplet as fatDroplet } from '@fortawesome/pro-thin-svg-icons/faDroplet';
import { faEllipsisStroke as fatEllipsisStroke } from '@fortawesome/pro-thin-svg-icons/faEllipsisStroke';
import { faEllipsisVertical as fatEllipsisVertical } from '@fortawesome/pro-thin-svg-icons/faEllipsisVertical';
import { faExpand as fatExpand } from '@fortawesome/pro-thin-svg-icons/faExpand';
import { faFolderMedical as fatFolderMedical } from '@fortawesome/pro-thin-svg-icons/faFolderMedical';
import { faGear as fatGear } from '@fortawesome/pro-thin-svg-icons/faGear';
import { faHeart as fatHeart } from '@fortawesome/pro-thin-svg-icons/faHeart';
import { faHeartCirclePlus as fatHeartCirclePlus } from '@fortawesome/pro-thin-svg-icons/faHeartCirclePlus';
import { faHome as fatHome } from '@fortawesome/pro-thin-svg-icons/faHome';
import { faHospitalUser as fatHospitalUser } from '@fortawesome/pro-thin-svg-icons/faHospitalUser';
import { faInfo as fatInfo } from '@fortawesome/pro-thin-svg-icons/faInfo';
import { faMagnifyingGlassChart as fatMagnifyingGlassChart } from '@fortawesome/pro-thin-svg-icons/faMagnifyingGlassChart';
import { faPerson as fatPerson } from '@fortawesome/pro-thin-svg-icons/faPerson';
import { faPlug as fatPlug } from '@fortawesome/pro-thin-svg-icons/faPlug';
import { faPlus as fatPlus } from '@fortawesome/pro-thin-svg-icons/faPlus';
import { faShareNodes as fatShareNodes } from '@fortawesome/pro-thin-svg-icons/faShareNodes';
import { faShieldVirus as fatShieldVirus } from '@fortawesome/pro-thin-svg-icons/faShieldVirus';
import { faSitemap as fatSitemap } from '@fortawesome/pro-thin-svg-icons/faSitemap';
import { faSquareCheck as fatSquareCheck } from '@fortawesome/pro-thin-svg-icons/faSquareCheck';
import { faTimeline as fatTimeline } from '@fortawesome/pro-thin-svg-icons/faTimeline';
import { faTriangleExclamation as fatTriangleExclamation } from '@fortawesome/pro-thin-svg-icons/faTriangleExclamation';
import { faUser as fatUser } from '@fortawesome/pro-thin-svg-icons/faUser';
import { faUserMagnifyingGlass as fatUserMagnifyingGlass } from '@fortawesome/pro-thin-svg-icons/faUserMagnifyingGlass';
import { faUsers as fatUsers } from '@fortawesome/pro-thin-svg-icons/faUsers';
import { faUsersGear as fatUsersGear } from '@fortawesome/pro-thin-svg-icons/faUsersGear';
import { faWatchFitness as fatWatchFitness } from '@fortawesome/pro-thin-svg-icons/faWatchFitness';
import { faWrench as fatWrench } from '@fortawesome/pro-thin-svg-icons/faWrench';
import React from 'react';
import { Helmet } from 'react-helmet';

import GlobalStyle from '@components/GlobalStyle';
import { ModalWrapper } from '@components/Modal';

import vitallLogo from '@images/logos/favicon.png';

library.add(
  // fad
  fadArrowDownUpLock,
  fadBan,
  fadBedFront,
  fadCalendarDay,
  fadCalendarDays,
  fadCapsules,
  fadClipboardMedical,
  fadCopy,
  fadDna,
  fadExpand,
  fadExpandWide,
  fadFaceViewfinder,
  fadHeadSideCough,
  fadHospitalWide,
  fadKey,
  fadLaptopMedical,
  fadLock,
  fadPaperPlane,
  fadPerson,
  fadPersonDotsFromLine,
  fadPersonWalking,
  fadRulerHorizontal,
  fadRulerVertical,
  fadScalpelLineDashed,
  fadShoePrints,
  fadSnooze,
  fadStethoscope,
  fadSyringe,
  fadTrophyStar,
  fadUserDoctor,
  fadUserNurse,
  fadUserShield,
  fadUsers,
  fadVials,
  fadWatchFitness,
  fadWeightScale,

  fadMonitorWaveform,
  fadLungs,
  fadHeartPulse,
  fadImages,
  fadImageSlash,
  fadHandDots,
  fadWavePulse,
  fadDroplet,
  fadDumbbell,
  fadTrash,
  fadChevronDown,
  fadCircleChevronDown,
  fadBell,
  fadCircleChevronLeft,
  fadCircleChevronRight,
  fadChevronRight,
  fadCircleInfo,
  fadPhone,
  fadCommentDots,
  fadLocationDot,
  fadCity,
  fadFireFlameCurved,
  fadGauge,
  fadGaugeCircleBolt,
  fadTemperatureHalf,
  fadFaceSmile,
  fadCommentQuestion,
  fadCircleExclamation,
  fadCircleCheck,
  fadCheck,
  fadCircleX,
  fadCircleXmark,
  fadFileLines,
  fadShareNodes,
  fadShieldHalved,
  fasMinus,
  fasStar,
  fasTilde,
  fasWatchFitness,
  fadEye,
  fadFile,
  fadFiles,
  fadImage,
  fadIdCard,
  fadCircleMinus,
  fadMagnifyingGlass,
  fadMagnifyingGlassChart,
  fadAbacus,
  fadSliders,
  fadFireFlame,
  fadAddressCard,
  fadAddressBook,
  fadDisplayMedical,
  fadNotesMedical,
  fadTimeline,
  fadAlarmClock,
  fadRepeat,
  fadPlus,
  fadGavel,
  fadPlug,
  fadSitemap,
  fadGear,
  fadHome,
  fadHorizontalRule,
  fadDash,
  fadHyphen,
  fadFolderMedical,
  fadUser,
  fadUserPlus,
  fadUserMinus,
  fadCircleUser,
  fadEllipsisStroke,
  fadUserLarge,
  fadFileMedical,
  fadFilesMedical,
  fadDownload,
  fadFilePdf,
  fadPen,
  fadSpinnerThird,
  fadScrewdriverWrench,
  fadRightFromBracket,
  fadTruckMedical,
  fadTriangleExclamation,
  fadUserLock,
  fadWrench,
  fadBed,
  fadFaceSleeping,
  fadAlarmSnooze,
  fadPersonRunningFast,
  fadChartSimple,
  fadHeart,
  fasHistory,

  // fas
  fas2,
  fasAddressBook,
  fasAlarmClock,
  fasAlarmSnooze,
  fasArrowDown,
  fasArrowLeft,
  fasArrowRight,
  fasArrowRotateRight,
  fasArrowUp,
  fasCalendarCheck,
  fasChartSimple,
  fasCheck,
  fasChevronDown,
  fasChevronsDown,
  fasChevronUp,
  fasChevronsUp,
  fasChevronLeft,
  fasChevronRight,
  fasCircle,
  fasCircleCheck,
  fasCircleSmall,
  fasCircleUser,
  fasCircleX,
  fasCircleXmark,
  fasClipboardMedical,
  fasClockRotateLeft,
  fasCloudArrowUp,
  fasComment,
  fasCopy,
  fasDash,
  fasDownload,
  fasDroplet,
  fasDumbbell,
  fasEllipsis,
  fasEllipsisStroke,
  fasEllipsisVertical,
  fasEnvelope,
  fasEnvelopeCircleCheck,
  fasExpand,
  fasEye,
  fasFaceViewFinder,
  fasFaceSleeping,
  fasFaceSmile,
  fasFile,
  fasFileExport,
  fasFileLines,
  fasFireFlame,
  fasFireFlameCurved,
  fasFolderMedical,
  fasGauge,
  fasGaugeCircleBolt,
  fasGear,
  fasGrid,
  fasHeart,
  fasHeartPulse,
  fasHome,
  fasHospitalUser,
  fasHyphen,
  fasImages,
  fasInfo,
  fasList,
  fasLoader,
  fasLocationDot,
  fasLungs,
  fasMagnifyingGlass,
  fasMagnifyingGlassChart,
  fasMerge,
  fasMessageSms,
  fasMessageXmark,
  fasMonitorWaveform,
  fasMoonStars,
  fasPencil,
  fasPerson,
  fasPhone,
  fasCirclePause,
  fasCirclePlay,
  fasPlus,
  fasRightLeft,
  fasRulerHorizontal,
  fasRulerVertical,
  fasShareNodes,
  fasShoePrints,
  fasPlug,
  fasSitemap,
  fasSplit,
  fasSquare,
  fasSquareCheck,
  fasSun,
  fasTable,
  fasTemperatureHalf,
  fasTimeline,
  fasTrash,
  fasTrashArrowUp,
  fasTriangleExclamation,
  fasUser,
  fasUserDoctor,
  fasUserMagnifyingGlass,
  fasUsers,
  fasUsersGear,
  fasWavePulse,
  fasWeightScale,
  fasWrench,
  fasXmark,
  fasBrain,
  fasMoon,
  fasShield,
  fasWind,
  fasPalette,
  // far
  farBrain,
  farChartSimple,
  farCircle,
  farCircleQuestion,
  farClipboard,
  farEnvelope,
  farMessage,
  farMobile,
  farMinus,
  farCircle,
  farPaperclip,
  farChevronDown,
  farTruckMedical,
  farCalendarDays,
  farDna,
  farNotesMedical,
  farSyringe,
  farHospitalWide,
  farVials,
  farStethoscope,
  farScalpelLineDashed,
  farCapsules,
  farMonitorWaveform,
  farImages,
  farRepeat,
  farHandDots,
  farUser,
  farUsers,
  farPersonRunningFast,
  farPersonWalking,
  farPerson,
  farSnooze,
  farSquare,
  farBed,
  farClock,
  farCircleInfo,
  farCircleCheck,
  // fal
  falBars,
  falCircleInfo,
  falSliders,

  // fat
  fatAddressBook,
  fatAlarmClock,
  fatArrowLeft,
  fatArrowRight,
  fatBrain,
  fatCircle,
  fatClipboardMedical,
  fatComment,
  fatDroplet,
  fatEllipsisStroke,
  fatEllipsisVertical,
  fatExpand,
  fatFolderMedical,
  fatGear,
  fatHeart,
  fatHeartCirclePlus,
  fatHome,
  fatHospitalUser,
  fatInfo,
  fatMagnifyingGlassChart,
  fatPerson,
  fatPlus,
  fatShareNodes,
  fatShieldVirus,
  fatPlug,
  fatSitemap,
  fatSquareCheck,
  fatTimeline,
  fatTriangleExclamation,
  fatUser,
  fatUserMagnifyingGlass,
  fatUsers,
  fatUsersGear,
  fatWatchFitness,
  fatWrench
);

const GlobalLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return null;
  }
  return (
    <>
      <GlobalStyle />
      <Helmet>
        <title>VITALL Engage</title>
        <link href={vitallLogo} rel="icon" type="image/png" />
      </Helmet>
      <ModalWrapper>{children}</ModalWrapper>
    </>
  );
};

export default GlobalLayout;
